import React, { useEffect, useState, useRef } from "react";
import "../NFTDetailDesign.css";
import { addComment, getComment } from "../../../api/nft/nft";
import { errorMessageHandler, fetchUserProfileImage, formatTime } from "../../../utils/utils";
import AddAndFetchReaction from "../Reactions/AddAndFetchReaction";
import { AvatarGenerator } from 'random-avatar-generator';
import CommentSkelon, { LoadMoreCommentSkelon } from "../Comment/CommentSkelon";
import LoadingError from "../Comment/LoadingError";
import NotExistMsg from "../Comment/NotExistMsg";
import LoadMoreSection from "../../Common/LoadMoreSection";
import { Link } from "react-router-dom";
let generator = new AvatarGenerator();
const AddAndFetchComment = ({ id, currentUser }) => {
   

    const commentsListRef = useRef(null);

    // Prevent page scroll when scrolling inside comments
    useEffect(() => {
        const container = commentsListRef.current;
        if (!container) return;

        const handleWheel = (e) => {
            const { scrollTop, scrollHeight, clientHeight } = container;
            const scrollable = scrollHeight > clientHeight;

            // Only prevent default if the container is scrollable
            // This prevents page scroll while scrolling inside comments
            if (scrollable) {
                e.stopPropagation();
            }
        };

        // Use passive: false to allow preventDefault if needed
        container.addEventListener('wheel', handleWheel, { passive: false });

        return () => {
            container.removeEventListener('wheel', handleWheel);
        };
    }, []);

    const [comment, setComment] = useState("")
    const [commentLoader, setCommentLoader] = useState(false)
    const [commentError, setCommentError] = useState("")
    //Fetch comment
    const [commentList, setCommentList] = useState([])
    const [commentListPagination, setCommentListPagination] = useState({})
    const [fetchCommentLoader, setFetchCommentLoader] = useState(false)
    const [fetchCommentError, setFetchCommentError] = useState("")
    const [fetchCommentPage, setFetchCommentPage] = useState(1)

    useEffect(() => {
        fetchComment()
    }, [])


    const fetchComment = async (page = fetchCommentPage) => {
        try {
            setFetchCommentLoader(true);
            const { data } = await getComment(id, page);
            const incoming = data?.data?.comments || [];
            const pagination = data?.data?.pagination || {};
            setCommentList(prev => (page === 1 ? incoming : [...prev, ...incoming]));
            setCommentListPagination({
                ...pagination,
                current_page: Number(pagination.current_page)
            });
            setFetchCommentPage(page);
            setFetchCommentLoader(false);
            setFetchCommentError("");
        } catch (e) {
            setFetchCommentLoader(false);
            setFetchCommentError(errorMessageHandler(e));
        }
    };

    //Add comment
    const commentHandler = async () => {
        try {
            setCommentLoader(true);
            setCommentError("");
            const { data } = await addComment(id, { review_text: comment });
            setCommentList(prev => {
                const alreadyExists = prev.some(c => c._id === data.data._id);
                return alreadyExists ? prev : [data.data, ...prev];
            });
            setComment("");
            setCommentLoader(false);
        } catch (e) {
            setCommentLoader(false);
            setCommentError(errorMessageHandler(e));
        }
    };

    //Fetch comment
    useEffect(() => {
        if (fetchCommentPage > 1) fetchComment();
    }, [fetchCommentPage]);

    const loadMoreComment = () => {
        if (commentListPagination?.has_next_page) setFetchCommentPage(prev => prev + 1);
    };

    return (
        <div
            className="tab-pane fade show active"
            id="comments"
            role="tabpanel"
            aria-labelledby="comments-tab"
        >
            <div className="NFTDetailDesign__commentInput rounded p-3 mb-3">
                <div className="d-flex align-items-center gap-2">
                    <div className="rounded-circle NFTDetailDesign__avatar me-2" style={{ overflow: 'hidden' }}>
                        {
                            <img
                                src={fetchUserProfileImage(currentUser.profile_image)}
                                alt={currentUser?.user_name}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    borderRadius: '50%'
                                }}
                            />
                        }

                    </div>


                    <input
                        className={`form-control flex-grow-1 ${commentError ? 'is-invalid' : ''}`}
                        placeholder="Write a comment..."
                        value={comment}
                        onChange={(e) => {
                            setComment(e.target.value)
                            if (commentError) setCommentError("")
                        }}
                    />
                    <button
                        disabled={commentLoader}
                        style={{ opacity: commentLoader ? 0.4 : 1 }}
                        onClick={commentHandler}
                        className="btn BtnBlack px-3"
                    >
                        {commentLoader ? (
                            <>
                                Posting...
                            </>
                        ) : (
                            "Post"
                        )}
                    </button>

                </div>
                {commentError && (
                    <div className="mt-2 d-flex align-items-center" style={{
                        color: "#dc3545",
                        fontSize: "14px",
                        paddingLeft: "52px"
                    }}>
                        <i className="fas fa-exclamation-circle me-2" style={{ fontSize: "14px" }}></i>
                        <span>{commentError}</span>
                    </div>
                )}
                <AddAndFetchReaction currentUser={currentUser} id={id}></AddAndFetchReaction>
            </div>



            <div className="NFTDetailDesign__commentsList" ref={commentsListRef}>
                {fetchCommentError && !fetchCommentLoader ? (
                    <LoadingError callback={() => fetchComment(1)}></LoadingError>

                ) : fetchCommentLoader && commentList.length === 0 ? (
                    <CommentSkelon></CommentSkelon>
                ) : !fetchCommentLoader && commentList.length === 0 ? (
                    <NotExistMsg></NotExistMsg>
                ) : (
                    <>
                        {commentList.map((c, idx) => (
                            <div key={idx} className="d-flex align-items-start mb-3 comment-item">
                                <div className="rounded-circle NFTDetailDesign__avatar me-2" style={{ overflow: 'hidden' }}>
                                    {
                                        <img
                                            src={c?.user_meta?.profile_image ? fetchUserProfileImage(c?.user_meta?.profile_image) : generator.generateRandomAvatar(c?.user_meta?.user_name)}
                                            alt={c?.user_meta?.user_name}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                borderRadius: '50%'
                                            }}
                                        />
                                    }

                                </div>

                                <div className="w-100">
                                    <div className="d-flex align-items-center gap-2 mb-1">
                                        <Link to={`/profile/${c?.user_meta?.user_name}`}>
                                            <span className="fw-semibold">{c.user_meta.name}</span>
                                        </Link>
                                        <span className="text-secondary small">·</span>
                                        <span className="text-secondary small">{formatTime(c.createdAt)}</span>
                                    </div>
                                    <div className="comment-text">{c.review_text}</div>
                                </div>
                            </div>
                        ))}

                        <LoadMoreSection
                            hasNextPage={commentListPagination?.has_next_page}
                            onLoadMore={loadMoreComment}
                            isLoading={fetchCommentLoader}
                            loadMoreText="Load More Comments"
                            endMessage="That's all the comments!"
                            accentColor="17, 207, 243"
                            compact={true}
                        />




                    </>
                )}
            </div>



        </div>
    );
};

export default AddAndFetchComment;